import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import GiftInputField from "pages/GiftcardPurchase/GiftInputField";
import { withRouter } from "react-router";
import LoadingBubble from "components/LoadingBubble";

const VoucherActivationForm = ({ t, match, defaultEmail, activateFunc, loading }) => {
  const voucherCode = match.params.voucherCode;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const onActivateClick = () => {
    activateFunc(email || defaultEmail, password);
  };

  const onEmailChange = (value) => {
    setEmail(value);
  };

  const onPasswordChange = (value) => {
    setPassword(value);
  };

  return (
    <div className="voucher-activation-form">
      <GiftInputField type="text" placeholder={voucherCode} disabled />
      <GiftInputField type="email" placeholder={defaultEmail} onChangeFunc={onEmailChange} />
      <GiftInputField type="password" placeholder={"Password"} onChangeFunc={onPasswordChange} />

      {loading ? (
        <LoadingBubble color={"#DD4E52"} />
      ) : (
        <button className="button-red gift-next-button" onClick={onActivateClick}>
          {t("VOUCHER_ACTIVATE_BUTTON")}
        </button>
      )}
    </div>
  );
};

export default withRouter(withTranslation()(VoucherActivationForm));
